/**
 * Determines if a card type is interactive (requires user interaction to complete)
 * @param cardType - The type of the card
 * @returns true if the card is interactive, false if it's non-interactive
 */
export const isCardInteractive = (cardType: string): boolean => {
  // Fail closed if historical payloads contain the retired standalone type.
  // CardWrapper renders only a retirement notice and never enables progression.
  if (cardType === "assessment") {
    return true;
  }

  const interactiveCardTypes = [
    "knowledge_check",
    "match_exercise",
    "drag_and_drop_sorter",
    "data_visualization",
    "sequence_sort",
    // Treat Peda as interactive so learners can't skip without submitting
    "peda",
    // Treat Flashcard and Image Hotspot as interactive so learners must engage
    // with the content on every visit (no auto-advance on revisit)
    "flashcard",
    "image_hotspot",
    // Treat Poll as interactive when it drives conditional content
    // User must select an option before proceeding
    "poll",
  ];

  return interactiveCardTypes.includes(cardType);
};

/**
 * Determines if a card is non-interactive (can be completed immediately)
 * @param cardType - The type of the card
 * @returns true if the card is non-interactive, false if it's interactive
 */
export const isCardNonInteractive = (cardType: string): boolean => {
  return !isCardInteractive(cardType);
};
